import { useState, useCallback } from "react";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { CTASection } from "@/components/landing/CTASection";
import { Footer } from "@/components/landing/Footer";
import { LoginSchoolDialog } from "@/components/landing/LoginSchoolDialog";
import { TrialDialog } from "@/components/landing/TrialDialog";

export default function LandingPage() {
  const [trialOpen, setTrialOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [presetPackage, setPresetPackage] = useState(null);

  const openTrial = useCallback((pkg) => {
    setPresetPackage(typeof pkg === "string" ? pkg : null);
    setTrialOpen(true);
  }, []);
  const openLogin = useCallback(() => setLoginOpen(true), []);

  return (
    <div className="min-h-screen bg-[#060A12] text-white antialiased">
      <Header onTrial={openTrial} onLogin={openLogin} />
      <main>
        <Hero onTrial={openTrial} onLogin={openLogin} />
        <Features />
        <HowItWorks />
        <Pricing onTrial={openTrial} />
        <Testimonials />
        <FAQ />
        <CTASection onTrial={openTrial} onLogin={openLogin} />
      </main>
      <Footer onLogin={openLogin} />

      <TrialDialog open={trialOpen} onOpenChange={setTrialOpen} presetPackage={presetPackage} />
      <LoginSchoolDialog open={loginOpen} onOpenChange={setLoginOpen} />
    </div>
  );
}
